import { Component, OnInit, Input } from '@angular/core';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { InputComponent } from '../input/input.component';
import { FiltreService } from '../../filtre.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { formatNumber } from '@angular/common';
import { Subscription } from 'rxjs';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-integer-input',
  templateUrl: './integer-input.component.html',
  styleUrls: ['../input/input.component.css']
})
export class IntegerInputComponent extends InputComponent implements OnInit {
  @Input()
  max: number = 100000000;
  @Input()
  min: number = 0;
  @Input()
  sep: boolean = true;

  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
    ) {
    super(formulaireService, libelleService, filtreService, modeRenduService);
  }
  ngOnInit() {
    super.ngOnInit();
    // Ajout de FormControl servant à l’affichage de la valeur
    if (! this.formAffichage) {
      (this.currentControl.parent as UntypedFormGroup).setControl(this.labelAffichage, new UntypedFormControl(this.currentControl.value));
    }
    // Mise en place de la cohérence entre nos deux formControls
    // Comme toujours avec les subscriptions, ne pas oublier de fermer les ressources
    // Cela est fait automatiquement par la classe mère via subTab
    // TODO vérifier que les filtres marchent encore avec les emitEvent à false
    this.subTab.push(
      this.formAffichage.valueChanges.subscribe((value) => {
        const nouveauNombre = this.applicationBornes(this.texteVersNombre(value));
        this.currentControl.patchValue(nouveauNombre);
        this.formAffichage.patchValue(this.nombreVersTexte(nouveauNombre), {emitEvent: false});
      })
    );
    this.subTab.push(
      this.currentControl.valueChanges.subscribe((value) => {
        this.currentControl.patchValue(this.applicationBornes(value), { emitEvent: false });
        this.formAffichage.patchValue(this.nombreVersTexte(this.applicationBornes(value)), {emitEvent: false});
      })
    );
    // On force la mise à jour des valeurs
    this.currentControl.updateValueAndValidity();
  }

  /**
   * limite les nombres possibles pour respecter les bornes définies
   * @returns nombre respectant les bornes
   */
  protected applicationBornes(valeur: number): number {
    if (valeur > this.max || valeur < this.min) {
      // Vérification que la valeur en cours n’est pas abérente, sinon on réinitalise
      if (this.currentControl.value > this.max || this.currentControl.value < this.min) {
        return null;
      }
      // Pour l’utilisateur qui peut s’étonner de taper 153 et voir s’afficher 100
      // on laisse juste 15 (valeur du currentControl)
      return this.currentControl.value;
    } else {
      return valeur;
    }
  }
  /** Formate un nombre pour l’affichage à la française */
  protected nombreVersTexte (valeur: number): string {
    if(this.sep === true) {
      return valeur !== null ? formatNumber(valeur, 'fr') : '';
    }
    else return valeur!== null ? valeur.toString(): '';
  }
  /** Transforme l’affichage du nombre de type string en type number */
  protected texteVersNombre (valeur: string): number {
    if (valeur) {
      const nombre: any = Number.parseInt(valeur.replace(/\s/g, ''), 10);
      return isNaN(nombre) ? null : nombre;
    } else {
      return null;
    }
  }
  /** Besoin de réécrire cette fonction pour travailler sur le champ visible à l’écran */
  champTouche() {
    return this.formAffichage.touched;
  }
  /** Retourne le FormControl servant à l’affichage qui n’est plus le même que le FormControl d’origine */
  get formAffichage (): UntypedFormControl {
    return this.currentControl.parent.get(this.labelAffichage) as UntypedFormControl;
  }
  /** Label à affecter au FormControl servant à l’affichage */
  get labelAffichage (): string {
    return this.label + '_affichage';
  }
}
